import React from 'react'

import PropTypes from 'prop-types'

import './quote.css'

const Quote = (props) => {
  return (
    <div className={`quote-thq-quote-elm1 ${props.rootClassName} `}>
      <div className="quote-thq-quote-elm2">
        <span className="quote-thq-quote-elm3">{props.quote1}</span>
      </div>
      <div className="quote-thq-people-elm">
        <div className="quote-thq-person-elm">
          <img
            alt="person-avatar"
            src={props.avatar1}
            className="quote-thq-avatar-elm"
          />
          <div className="quote-thq-person-details-elm">
            <span className="quote-text1">{props.author1}</span>
            <span>{props.title1}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

Quote.defaultProps = {
  quote1:
    '“I love lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliquaation ullamco 100%."',
  rootClassName: '',
  title1: 'Manager @Vista Social',
  author1: 'Andy Smith',
  avatar1:
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/4a46e3f6-a2fb-4002-a0ce-bb246bd8698d/be94076d-9916-409d-bbc9-bfae1bfdf57c?org_if_sml=116621',
}

Quote.propTypes = {
  quote1: PropTypes.string,
  rootClassName: PropTypes.string,
  title1: PropTypes.string,
  author1: PropTypes.string,
  avatar1: PropTypes.string,
}

export default Quote
